/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {ReachAnalysisPageComponent} from './reach-analysis-page.component';


export function reachAnalysisStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.reach-analysis', {
          url: '/reach-analysis',
          views: {
            'content@app': {
              component: ReachAnalysisPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Reach Analysis"
          }
        });
  }, adnRouterHelper);
}
